module.exports = __webpack_public_path__ + "static/media/sensable_105.49c4c5a5.gif";